// @flow
import { postCreator } from '../../../../http';
import environment from '../../../../environment';

export type UploadImageResp = {
  +type: string;
  +id: string;
  +resourceGroup: string;
  +resourceId: string;
  +url: string;
};

export const endpoints = Object.freeze({
  UPLOAD_IMAGE: `${environment.apiUrl}/image/upload`,
  CANCEL_RESERVATION: `${environment.apiUrl}/sale/:orderId/progress/abandon`,
  SET_ITEM_INVOICE: `${environment.apiUrl}/sale/:orderId/:itemNumber/set-invoice`,
  PROGRESS_PURCHASE: `${environment.apiUrl}/sale/:orderId/progress/purchase`,
});

export const uploadImageApi = postCreator(fetch, endpoints.UPLOAD_IMAGE);
export const cancelReservationApi = postCreator(fetch, endpoints.CANCEL_RESERVATION);
export const setItemInvoiceApi = postCreator(fetch, endpoints.SET_ITEM_INVOICE);
export const progressPurchaseApi = postCreator(fetch, endpoints.PROGRESS_PURCHASE);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/reserved/api.js